<template>
    <div>
        <app-layout v-if="parameter">
	        <template v-slot:header>
	            <Header :title="getLocaleText(parameter, 'name')"
	                    :isNewButton="checkPermission('menuitem_store')"
	                    @new-button-click="add"
	                    @filter-div-status="datatable.filterStatus = $event">
	            </Header>
	        </template>
	        <template v-slot:header-mobile>
		        <HeaderMobile :title="getLocaleText(parameter, 'name')"
		                      :isNewButton="checkPermission('menuitem_store')"
		                      @new-button-click="add"
		                      @filter-div-status="datatable.filterStatus = $event">
	            </HeaderMobile>
	        </template>
            <datatable-filter v-show="datatable.filterStatus" @filter="filter" @filterClear="filterClear">
                <b-row>
                    <b-col sm="6" md="4" lg="3" xl="2">
                        <b-form-group :label="$t('name')">
                            <b-form-input v-model="datatable.queryParams.filter.name">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>
            <datatable :isLoading.sync="datatable.isLoading" :columns="datatable.columns" :rows="datatable.rows"
                :total="datatable.total" :queryParams="datatable.queryParams" :lineNumbers="false"
                @on-page-change="onPageChange" @on-sort-change="onSortChange" @on-per-page-change="onPerPageChange"
                v-show="datatable.showTable">
            </datatable>
            <CommonModal ref="modal" size="xl">
                <template v-slot:CommonModalTitle>
                    <div>{{ $t(id == 0 ? "add" : "edit") }}</div>
                </template>
                <template v-slot:CommonModalContent>
                    <div class="row mb-5 align-items-center">
                        <div class="col-12">
                            <ValidationObserver ref="storeForm">
                                <div class="row">
                                    <div class="col-6">
                                        <ValidationProvider name="menu_id" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('top_menu')">
                                                <MenuSelectbox v-model="form.menu_id" :validateError="errors[0]" />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-6">
                                        <ValidationProvider name="url" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('url')">
                                                <b-form-input type="url" v-model="form.url">
                                                </b-form-input>
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-6">
                                        <ValidationProvider name="new_window" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('new_window')">
                                                <yes-no-selectbox v-model="form.new_window" :validateError="errors[0]" />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-6">
                                        <ValidationProvider name="rank" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('rank')">
                                                <b-form-input type="number" step="1" v-model="form.rank">
                                                </b-form-input>
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-6" v-if="['2'].includes(parameter.user_type)">
                                        <b-form-group :label="$t('level')">
                                            <parameter-selectbox :multiple="true" v-model="form.program_level"
                                                                 code="program_levels"></parameter-selectbox>
                                        </b-form-group>
                                    </div>
                                    <b-form-group class="col-12" :label="$t('name')">
                                        <ValidationProvider name="name" rules="required" v-slot="{ valid, errors }">
                                            <b-input-group class="mb-3" :prepend="$t('variable_language')">
                                                <b-form-input v-model="form.name">
                                                </b-form-input>
                                            </b-input-group>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2">
                                            </b-form-invalid-feedback>
                                        </ValidationProvider>
                                        <ValidationProvider name="name_en" v-slot="{ valid, errors }">
                                            <b-input-group prepend="EN">
                                                <b-form-input v-model="form.name_en">
                                                </b-form-input>
                                            </b-input-group>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                                            </b-form-invalid-feedback>
                                        </ValidationProvider>
                                    </b-form-group>
                                    <div class="col-12">
                                        <ValidationProvider name="roles" v-slot="{ errors }">
                                            <b-form-group :label="$t('roles')">
                                                <multi-selectbox v-model="form.roles"
                                                                :valueType="'code'"
                                                                :multiple="true"
                                                                 :options="roleOptions"
                                                                :validate-error="errors[0]" />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </ValidationObserver>
                        </div>
                        <div class="col-12 mt-3 d-flex">
                            <b-button @click="store" type="button" variant="primary" class="btn-lg mr-2">
                                {{ $t("save") | toUpperCase }}
                            </b-button>
                        </div>
                    </div>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
import AppLayout from "@/layouts/AppLayout"
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"
import DatatableFilter from "@/components/datatable/DatatableFilter"
import Datatable from "@/components/datatable/Datatable"
import qs from "qs"
import MenuService from "@/services/MenuService"
import CommonModal from "@/components/elements/CommonModal"
import { ValidationObserver, ValidationProvider } from "vee-validate"
import YesNoSelectbox from "@/components/interactive-fields/YesNoSelectbox"
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox"
import RoleService from "@/services/RoleService"
import MenuSelectbox from "@/components/interactive-fields/MenuSelectbox.vue";


export default {
    components: {
        MenuSelectbox,
        AppLayout,
        Header,
	    HeaderMobile,
        DatatableFilter,
        Datatable,
        CommonModal,
        YesNoSelectbox,
        ValidationProvider,
        ValidationObserver,
        MultiSelectbox
    },
    metaInfo() {
        return {
            title: this.parameter ? this.getLocaleText(this.parameter, "name") : '',
        };
    },
    data() {
        return {
            parameter: null,
            menu_id: 0,
            id: 0,
            form: {},
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: "",
                        field: "buttons",
                        html: true,
                        sortable: false,
                        tdClass: "p-0 text-center w-40 align-middle",
                        buttons: [
                            {
                                text: this.$t("edit"),
                                class: "ri-edit-box-line",
                                permission: "menuitem_update",
                                callback: (row) => {
                                    this.id = row.id;
                                    this.loadData();
                                },
                            },
                            {
                                text: this.$t("delete"),
                                class: "ri-delete-bin-2-line",
                                permission: "menuitem_delete",
                                callback: (row) => {
                                    this.delete(row.id);
                                },
                            },
                            {
                                text: this.$t("menu_items"),
                                class: "ri-list-check ",
                                permission: "menuitem_index",
                                callback: (row) => {
                                    this.id = row.id;
                                    this.openMenu(row.id);
                                },
                                show: (row) => {
                                    return row.url == '' || row.url == null ? true : false
                                }
                            }
                        ],
                    },
                    {
                        label: this.$t("id"),
                        field: "id",
                        sortable: true,
                    },
                    {
                        label: this.$t("name"),
                        field: this.getLocaleField("name"),
                        sortable: true,
                    },
                    {
                        label: this.$t("url"),
                        field: 'url',
                        sortable: true,
                    },
                    {
                        label: this.$t("rank"),
                        field: 'rank',
                        sortable: true,
                    },
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: "id",
                    page: 1,
                    limit: 20,
                },
            },
            roleOptions: []
        };
    },
    methods: {
        openMenu() {
            if (this.id > 0) {
                this.$router.push("/menu/items/" + this.$route.params.id+'/items/'+this.id);
            }
        },
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        filterClear() {
            this.datatable.queryParams.filter = {};
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onSortChange(params) {
            const sortType = params[0].type == "desc" ? "-" : "";
            this.datatable.queryParams.sort = sortType + params[0].field;
            this.getRows();
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            this.datatable.queryParams.filter.menu_id = this.menu_id;
            const config = {
                params: {
                    ...this.datatable.queryParams,
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false }),
            };
            return MenuService.getAllItems(config)
                .then((response) => {
                    this.datatable.rows = response.data.data;
                    this.datatable.total = response.data.pagination.total
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },
        loadData() {
            if (this.id > 0) {
                MenuService.getMenus(this.id)
                    .then((response) => {
                        this.$refs.storeForm.reset();
                        this.form = response.data.data;
                        this.form.new_window = this.form.new_window == true ? 'E' : 'H'
                        this.$refs.modal.$refs.commonModal.show();
                    })
                    .catch((error) => {
                        if (error.data.message) {
                            this.$toast.error(this.$t("api." + error.data.message));
                        }
                    });
            }
        },
        async store() {
            const isValid = await this.$refs.storeForm.validate();
            if (isValid) {
                this.form.new_window = this.form.new_window === 'E'
                let formData = { ...this.form };
                this.setBooleans(formData);
                if (this.id == 0) {
                    MenuService.storeItem(formData)
                        .then((response) => {
                            this.$toast.success(this.$t("api." + response.data.message));
                            this.$refs.modal.$refs.commonModal.hide()
                            this.getRows()
                        })
                        .catch((error) => {
                            this.showErrors(error, this.$refs.storeForm)
                        })
                } else {
                    MenuService.updateItem(this.id, formData)
                        .then((response) => {
                            this.$toast.success(this.$t("api." + response.data.message));
                            this.$refs.modal.$refs.commonModal.hide()
                            this.getRows()
                        })
                        .catch((error) => {
                            this.showErrors(error, this.$refs.storeForm)
                        })
                }
            }
        },

        delete(id) {
            this.deleteModal(() => {
                MenuService.deleteMenuItem(id)
                    .then((response) => {
                        this.filter();
                        this.$toast.success(this.$t("api." + response.data.message));
                    })
                    .catch((error) => {
                        this.$toast.error(this.$t("api." + error.data.message));
                    });
            });
        },
        add() {
            this.id = 0;
            this.$refs.storeForm.reset();
            this.form = {};
            this.$refs.modal.$refs.commonModal.show();
        },

        getRoles() {
            this.roleOptions = []
            const config = {
                params: {
                    limit: -1
                }
            }

            RoleService.getAll(config)
                .then((response) => {
                    this.roleOptions = response?.data?.data?.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
                        ?.map((item) => {
                            return {
                                value: item.name,
                                text: this.getLocaleText(item, 'explanation')
                            }
                        }) ?? []
                })
                .catch((e) => {
                    this.showErrors(e)
                })
        }
    },
    created() {
        this.getRoles()
        this.menu_id = this.$route.params.id;

        if (this.menu_id) {
            MenuService.getMenu(this.menu_id).then((response) => {
                this.parameter = response.data.data;
                this.menu_id = response.data.data.id;
                this.getRows();
            });
        } else {
            this.$router.push("404");
        }
    },
};
</script>
